export const ALLOWED_PHONE_COUNTRIES = [
    // North America & Caribbean
    'ag',
    'bs',
    'bb',
    'bm',
    'ca',
    'ky',
    'do',
    'jm',
    'mx',
    'pr',
    'lc',
    'tt',
    'tc',
    'us',
    'vg',
    'vi',
    // Asia / Middle East
    'af',
    'cn',
    'hk',
    'in',
    'jp',
    'kr',
    'pk',
    'ph',
    'ru',
    'kz',
    'sa',
    'sg',
    'tr',
    'ae',
    // Europe
    'at',
    'be',
    'cz',
    'dk',
    'fi',
    'ax',
    'fr',
    'de',
    'gr',
    'gg',
    'je',
    'ie',
    'im',
    'it',
    'xk',
    'lu',
    'mt',
    'mc',
    'nl',
    'no',
    'pl',
    'pt',
    'mk',
    'ro',
    'rs',
    'es',
    'se',
    'ch',
    'nc',
    'ua',
    'gb',
    // South America
    'br',
    'cl',
    'co',
    'py',
    'pe',
    // Africa
    'cm',
    'eg',
    'et',
    'lr',
    'ma',
    'eh',
    'na',
    'so',
    'za',
    // Oceania
    'as',
    'au',
    'cc',
    'cx',
    'gu',
    'nz',
    'mp',
    'vu', // Vanuatu (+678)
];
